import Swiper, { Lazy, Autoplay, Pagination, Keyboard } from 'swiper'
Swiper.use([Lazy, Autoplay, Pagination, Keyboard])

import { select } from '@js/util/select'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

select('.wpce-slider-integrated', sliderElement => {
  let swiper = new Swiper(
    `#${sliderElement.dataset.swiperId}`,
    JSON.parse(sliderElement.dataset.options),
  )

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Handle previous button
  function onPrevClick() {
    swiper.slidePrev()
  }
  let prevButton = sliderElement.querySelector('.swiper-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideNext()
  }
  let nextButton = sliderElement.querySelector('.swiper-button-next')
  nextButton?.addEventListener('click', onNextClick)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  return () => {
    swiper.destroy()
  }
})
